// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"48ed6bd1","708":"0defbb01"}[chunkId] + ".chunk.js";
};